/* eslint-disable global-require */
const axios = require('axios')

// Cria a instância do axios com a URL base
const api = axios.create({
  baseURL: 'https://chat-api.manyconvert.com',
})

async function listarAtalhos(chat_id) {
  const contato = await api.get(
    `/api/messages/atalhos/${chat_id}`,
  )

  return contato.data
}

async function criarAtalho(data) {
  const contato = await api.post(
    '/api/messages/atalhos', data,
  )

  return contato.data
}

async function editarAtalho(data) {
  const contato = await api.put(
    '/api/messages/atalhos', data,
  )

  return contato.data
}

async function deletarAtalho(id) {
  const contato = await api.delete(
    `/api/messages/atalhos/${id}`,
  )

  return contato.data
}

module.exports = {
  listarAtalhos,
  criarAtalho,
  editarAtalho,
  deletarAtalho,
}
